import React from "react";
import { CalendarDays, MapPin, Users, FileText } from "lucide-react";

const Awards2025 = () => {
  /* -------------------- DATA -------------------- */

const awards = [
  {
    category: "Best Researcher Award",
    domain: "Computer Applications",
    nominee: "Shalli Rani, Chitkara University, Punjab, India",
  },
  {
    category: "Innovation Awards",
    domain: "Cloud Computing",
    nominee: "Sarat Mahavratayajula, The Sherwin-Williams Company",
  },
  {
    category: "Industry Transformation Awards",
    domain: "AI and Machine Learning",
    nominee: "Sahil Verma, Rayat Bahra University, Mohali, Punjab",
  },
  {
    category: "Young Researcher Award",
    domain: "Computer Applications",
    nominee: "Pankaj Rahi, Lovely Professional University, Phagwara, Punjab India",
  },
  {
    category: "Emerging Technology Impact Awards",
    domain: "Electric Vehicle (EV) and Battery Manufacturing",
    nominee: "Omkar Bhalekar, Tesla USA",
  },
  {
    category: "Young Researcher Award",
    domain: "Computer Vision",
    nominee: "Sheshang Degadwala, Sigma University, India",
  },
  {
    category: "Strategic Data Modernization Award",
    domain: "Data Analytics",
    nominee: "Mahesh Kumar Goyal, Google LLC USA",
  },
  {
    category: "Innovation Awards",
    domain: "Cloud-driven Automation and Secure Systems",
    nominee: "Sesha Sai Sravanthi Valiveti, Bank of America, USA",
  },
  {
    category: "Emerging Technology Impact Awards",
    domain: "Enterprise Change & Release Management",
    nominee: "Sai Raghavendra Varanasi, Cigna Health Care, USA",
  },
  {
    category: "The Enterprise AI & Fintech Innovation Award",
    domain: "AI & Fintech",
    nominee: "Harshini Gadam, Staples Inc, USA",
  },
  {
    category: "SAP and Enterprise System Innovation Awards",
    domain: "SAP and Enterprise System",
    nominee: "Gururaj Balkrishna K Y, Accenture PLC, USA",
  },
  {
    category: "The Industry Innovation Award",
    domain: "Cloud Computing",
    nominee: "Aditya Gupta, Amazon Web Services, USA",
  },
  {
    category:
      "Women in Technology: Excellence in Research & Leadership Award",
    domain:
      "Information Security, AI, Data Science, IoT and Machine Learning",
    nominee: "Priya Matta, Tula's Institute, India",
  },
];

  return (
    <div className="min-h-screen bg-slate-50 px-4 py-10">
      <div className="mx-auto max-w-5xl">
        {/* Header */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-4xl font-bold text-slate-800">
            Awards & Recognitions - ICCRDA 2025
          </h1>
          
          <hr className="mt-4 mx-auto w-48 border-2 border-indigo-600" />
        </div>

        {/* Awards Table */}
        <div className="bg-white rounded-2xl shadow-md p-6 md:p-8">
          <div className="overflow-x-auto">
            <table className="min-w-full border text-sm">
              <thead className="bg-slate-100">
                <tr>
                  <th className="border px-4 py-2">Award Category</th>
                  <th className="border px-4 py-2">Domain</th>
                  <th className="border px-4 py-2">Nominee</th>
                </tr>
              </thead>
              <tbody>
                {awards.map((a, i) => (
                  <tr key={i} className="hover:bg-slate-50">
                    <td className="border px-4 py-2 font-medium">
                      {a.category}
                    </td>
                    <td className="border px-4 py-2">{a.domain}</td>
                    <td className="border px-4 py-2">{a.nominee}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Awards2025;
